import { render } from "./DocumentationView.vue?vue&type=template&id=511b300d&scoped=true"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"

import "./DocumentationView.vue?vue&type=style&index=0&id=511b300d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511b300d"]])

export default __exports__